<div class="title" mat-dialog-title>
  <p>Omgå BankID-verifisering</p>
  <app-ice-icon-button
    ariaLabel="Lukk dialog"
    matDialogClose
    size="32px"
    testId="close-bypass-order-modal"
    [iconName]="IconNames.ice_close"
  />
</div>
<div class="content" mat-dialog-content>
  <app-ice-alert type="info">
    Du er fullt ansvarlig for å gjennomføre en korrekt manuell ID-kontroll og må ikke gå videre før legitimasjonen er
    verifisert uten tvil
  </app-ice-alert>
  <form [formGroup]="form" (ngSubmit)="submitBypass()">
    <app-ice-textarea
      formControlName="bypassReason"
      label="Din begrunnelse for å omgå BankID"
      ngDefaultControl
      rows="2"
      testId="bypass-reason"
    />
    <div class="actions-row">
      <app-ice-button class="cancel-button" color="outlined" matDialogClose testId="cancel-bypass">Avbryt</app-ice-button>
      <app-ice-button
        class="submit-button"
        testId="submit-bypass"
        type="submit"
        [disabled]="form.invalid"
        [isLoading]="isLoading()"
      >
        Bekreft
      </app-ice-button>
    </div>
  </form>
</div>
